import React, { useState, useEffect } from "react";
import userimg from "../../assets/user.png";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import axios from "axios";

export default function Rightsidebar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [hasMore, setHasMore] = useState(true); // Track if more data is available
  const [followings, setFollowings] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // ✅ Fetch all friends and followers
  const fetchFollowers = async (page=1) => {
    setLoading(true);
    setError(null);

    const token = sessionStorage.getItem("accessToken"); // Assuming you store token in session storage

    const requestBody = {
      filters: {
        isNotFriends: true,   // ✅ Added isNotFriends filter
      },
            page: page,
      limit: 10
    };

    try {
      const response = await axios.post(
        "https://pipaan.com360degree.com/api/user/get-all-users",
        requestBody,
        {
          headers: {
            "token": `${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.success) {
        const newFollowers = response.data.result.users;

        // Append new followers to the existing list
        setFollowers((prev) => [...prev, ...newFollowers]);

        // Check if there are more followers to load
        if (newFollowers.length < 10) {
          setHasMore(false); // No more data if fewer than 10 items are returned
        }
      } else {
        setError("Failed to fetch followers.");
      }
    } catch (error) {
      console.error("❌ Error fetching followers:", error);
      setError("An error occurred while fetching followers.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFollowers(currentPage);
  }, [currentPage]);
  // ✅ Load more followers when "Show More" is clicked
  const loadMoreFollowers = () => {
    if (hasMore) {
      setCurrentPage((prevPage) => prevPage + 1); // Increment the page number
    }
  };

  // ✅ Function to send a friend request
const sendFriendRequest = async (userId) => {
  const token = sessionStorage.getItem("accessToken");

  if (!token) {
    console.error("No token found. Please log in.");
    return;
  }

  try {
    const response = await axios.post(
      "https://pipaan.com360degree.com/api/friend/add-friend",
      {
        status: "pending",      // ✅ Friend request status
        user_id: userId        // ✅ Target user ID
      },
      {
        headers: {
          "token": `${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    if (response.data.success) {
      console.log("Friend request sent successfully:", response.data);
      
      // ✅ Optionally, update the UI to reflect the request status
      setFollowers((prev) =>
        prev.map((user) =>
          user.id === userId ? { ...user, isFriendRequestSent: true } : user
        )
      );
    } else {
      console.error("Failed to send friend request:", response.data.message);
    }
  } catch (error) {
    console.error("❌ Error sending friend request:", error);
  }
};
const handleUnfollow = async (friendId) => {
  const token = sessionStorage.getItem("accessToken");
  if (!token) return console.error("No token found, please log in.");
// ✅ Show confirmation popup
const isConfirmed = window.confirm("Are you sure you want to unfollow this user?");
if (!isConfirmed) return; // Stop execution if user cancels

  // ✅ Retrieve the user2id from sessionStorage
 
  try {
    const response = await fetch("https://pipaan.com360degree.com/api/friend/add-friend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "token": `${token}`,
      },
      body: JSON.stringify({
        status: "deleted",    // ✅ Use "unfollow" status
        user_id: friendId,
      }),
    });

    if (response.data.success) {
      console.log(`Unfollowed user ID: ${friendId}`);

      setFollowers((prev) =>
        prev.map((user) =>
          user.id === friendId
            ? { ...user, isFriendRequestSent: false, friendshipStatus: false }
            : user
        )
      );
    } else {
      console.error("Failed to unfollow user:", response.data.message);
    }
  } catch (error) {
    console.error("Error unfollowing user:", error);
  }
};
  return (
    <div className="">
      {/* Right Sidebar */}
      <aside className="rightsidebar w-80 bg-white p-3 hidden lg:block">
        <div
          className={`right-sidebar-fixed bg-white shadow-md transition-all duration-300 ${isScrolled ? "top-0 mt-1" : "top-[100px]"
            }`}
          style={{
            position: "fixed",
            right: 0,
            marginTop: "30px",
            height: "100vh",
            // width: "auto",
            overflowY: "auto",
            padding: "15px",
          }}
        >
          <h3 className="followers-title mb-4">Based on Your Followers</h3>

          {loading && currentPage === 1 ? (
            <p>Loading...</p>
          ) : error ? (
            <p className="text-red-500">{error}</p>
          ) : followers?.length > 0 ? (
<>
             { followers.map((user, index) => (
                <div key={index} className="followers flex items-center justify-between space-x-4 mb-4">
                  <div className="flex items-center">
                    <img
                      src={user.profile_image || userimg}  // Use API profile image or fallback
                      alt={user.username}
                      className="w-12 h-12 rounded-full"
                    />
                    <div className="ml-1">
                      <p className="text-[14px] font-semibold">{user.first_name} {user.last_name}</p>

                      {/* <p className="titlesemibold font-semibold">{user.username}</p> */}
                      <p className="members text-sm text-gray-500">{user.followersCount} followers</p>
                    </div>
                  </div>
                 {/* ✅ Follow Button */}
                 <button
                    onClick={() =>
                      user.isFriendRequestSent || user.friendshipStatus
                        ? handleUnfollow(user.id)
                        : sendFriendRequest(user.id)
                    }
                    className={`follow-cta px-4 py-1 rounded-lg ${
                      user.isFriendRequestSent || user.friendshipStatus
                        ? "bg-gray-400 text-white"
                        : "bg-blue-500 text-white"
                    }`}
                  >
                    {user.isFriendRequestSent || user.friendshipStatus
                      ? "Unfollow"
                      : "Follow"}
                  </button>
                </div>
              ))}
              {hasMore && (
                <p
                  onClick={loadMoreFollowers}
                  className="text-black-500 text-center cursor-pointer mt-4"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Show More"}
                </p>
              )}
            </>
          ) : (
            <p>No followers found.</p>
          )}

          <hr className="my-4" />
          <h3 className="font-semibold mt-6 mb-4">Based on Your Groups</h3>
          {loading ? (
            <p>Loading...</p>
          ) : (
            followers?.length > 0 ? (
              followers.slice(0, 5).map((group, index) => (
                <div key={index} className="followers flex items-center justify-between space-x-4 mb-4">
                  <div className="flex items-center">
                    <img
                      src={group.profile_image || userimg}
                      alt={group.username}
                      className="w-12 h-12 rounded-full"
                    />
                    <div className="ml-1">
                      <p className="titlesemibold font-semibold">{group.username}</p>
                      <p className="members text-sm text-gray-500">{group.followers_count} followers</p>
                    </div>
                  </div>
                  <button className="follow-cta bg-blue-500 text-white px-4 py-1 rounded-lg">
                    Follow
                  </button>
                </div>
              ))
            ) : (
              <p>No groups found.</p>
            )
          )}
        </div>
      </aside>
    </div>
  );
}
